
















import Vue from "vue";

export default Vue.extend({
  methods: {
    goHome() {
      window.open("https://www.deltahacks.com/", "_self");
    },
    isMobile: (): boolean => window.innerWidth <= 720,
  },
});
